import { render } from "./FundGuPiao.vue?vue&type=template&id=0cf174e8"
import script from "./FundGuPiao.vue?vue&type=script&lang=js"
export * from "./FundGuPiao.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__